import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import CookieBanner from './components/CookieBanner'
import Home from './pages/Home'
import Blogs from './pages/Blogs'
import ContactUs from './pages/ContactUs'
import TermsConditions from './pages/TermsConditions'
import PrivacyPolicy from './pages/PrivacyPolicy'
import CookiePolicy from './pages/CookiePolicy'
import HCM from './pages/products/HCM'
import TakeawaySystem from './pages/products/TakeawaySystem'
import AccountManagement from './pages/products/AccountManagement'
import TextileERP from './pages/products/TextileERP'
import ManufacturingInventory from './pages/products/ManufacturingInventory'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products/human-capital-management" element={<HCM />} />
          <Route path="/products/takeaway-system" element={<TakeawaySystem />} />
          <Route path="/products/account-management" element={<AccountManagement />} />
          <Route path="/products/textile-erp" element={<TextileERP />} />
          <Route path="/products/manufacturing-inventory" element={<ManufacturingInventory />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookiePolicy />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </>
  )
}
